module.exports = __webpack_public_path__ + "dashboard/img/history.e5c8d652cbe4110b97faa6449b6ecd56.svg";